export default "__VITE_ASSET__BETnU$nB__"